import { render, staticRenderFns } from "./slot-docs-item.vue?vue&type=template&id=3f697dd2&scoped=true&lang=html&"
import script from "./slot-docs-item.vue?vue&type=script&lang=js&"
export * from "./slot-docs-item.vue?vue&type=script&lang=js&"
import style0 from "./slot-docs-item.vue?vue&type=style&index=0&id=3f697dd2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f697dd2",
  null
  
)

component.options.__file = "slot-docs-item.vue"
export default component.exports